/**
 * Detect fn
 */
export default () => 'findIndex' in Array.prototype
